// Space taken by each chevron between crumbs, including the gap on either side.
export const separatorWidth = 20 + 2 * 8;

// The "…" button that holds the folded crumbs.
export const foldButtonWidth = 28;

/**
 * Works out how many crumbs to fold into the "…" menu so the trail fits on one
 * line, given each crumb's narrowest width (long names shorten before
 * anything folds). The first crumb and the current page always stay visible,
 * so the crumbs straight after the first fold away first.
 */
export function countFoldedCrumbs(
  crumbWidths: number[],
  availableWidth: number,
): number {
  const maximumFoldedCount = Math.max(crumbWidths.length - 2, 0);
  let foldedCount = 0;
  while (
    foldedCount < maximumFoldedCount &&
    getTrailWidth(crumbWidths, foldedCount) > availableWidth
  ) {
    foldedCount++;
  }
  return foldedCount;
}

export function getTrailWidth(crumbWidths: number[], foldedCount: number) {
  const shownWidths = crumbWidths.filter(
    (_, index) => index === 0 || index > foldedCount,
  );
  const crumbsWidth = shownWidths.reduce((sum, width) => sum + width, 0);
  const foldWidth = foldedCount > 0 ? foldButtonWidth + separatorWidth : 0;
  return (
    crumbsWidth +
    foldWidth +
    separatorWidth * Math.max(shownWidths.length - 1, 0)
  );
}
